import { createSelector } from 'reselect';
import { getDraft, getMaps } from '../pairingSelector';
import { SelectTablesView } from './view/SelectTablesView';
import { MapView } from './view/MapView';
import { formValueSelector } from 'redux-form';
import { AppState } from '@Redux/store';
import { VersionGame } from '@Models';

const getState = (state: AppState): AppState => state;

// Decorate with connect to read form values
// @ts-ignore
const selector = formValueSelector('create_draft'); // <-- same as form name

export const selectTablesPresenter = createSelector(
  [getState, getDraft, getMaps],
  (state, draft, maps): SelectTablesView => {
    const size = selector(state, 'size');
    const game: VersionGame = selector(state, 'game');
    const tables: MapView[] = selector(state, 'tables') ?? new Array<MapView>();

    let addTables = new Array<MapView>();
    for (let i = tables.length; i < size; i++) {
      addTables.push(MapView.empty());
    }

    return new SelectTablesView({
      size: size,
      maps: (maps.entity ?? [])
        .filter((m) => m.game === game)
        .map((item) => {
          const selecteable =
            size > tables.filter((x) => x.mapId).length ||
            tables.some((element) => element.mapId === item.id);
          return MapView.fromMap(item, selecteable, false);
        }),
      hasError: maps.hasError,
      isMapsLoading: maps.isLoading,
      isLoading: draft.isLoading,
      tables: tables.concat(addTables),
    });
  },
);
